function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useState } from 'react';
import { CustomModal, MultiSelectFilterPicker, Page, PageContentHeader, PageEmptyState, PageErrorState, Searchbox, TableList, Typography, useDidUpdate, useOverlayContext } from 'seagull';
import { CreateProposalButton } from "../../../components/CreateProposalButton/CreateProposalButton";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { ErrorText } from "../../../constants";
import { useRestfulWrapper } from "../../../hooks/useRestfulWrapper";
import { useServiceTemplateApi } from "../../../hooks/useServiceTemplateApi";
import { modalSize } from "../../../infra/modals";
import { handlePromise } from "../../../infra/utils";
import NoDataIcon from "../../assets/NoDataIcon";
import { serviceTemplateModel } from "../../../models";
import { PracticeManagement } from "../../../types/api.model";
import { getPMDetails } from "../pm.utils";
import PMMapServiceField from "../PMMapServiceField/PMMapServiceField";
import styles from "./PMMapServicesModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getTableConfig(pmName) {
  const tableConfig = [{
    columnDef: {
      width: [100, 500]
    },
    headerItem: {
      value: 'Anchor service'
    }
  }, {
    columnDef: {
      width: 550
    },
    headerItem: {
      value: "".concat(getPMDetails(pmName).name, " ").concat(getPMDetails(pmName).template)
    }
  }];
  return {
    columnDefs: tableConfig.map(config => config.columnDef),
    headerItems: tableConfig.map(config => config.headerItem)
  };
}
var MappedStatus = /*#__PURE__*/function (MappedStatus) {
  MappedStatus["Mapped"] = "mapped";
  MappedStatus["Unmapped"] = "unmapped";
  return MappedStatus;
}(MappedStatus || {});
function filterTemplates(templates, search, mappedStatusFilter, getServiceTemplateIntegratedIds) {
  const trimmedLowercaseSearch = search.trim().toLowerCase();
  return templates.filter(template => {
    const includedBySearch = !trimmedLowercaseSearch || template.name.toLowerCase().includes(trimmedLowercaseSearch);
    const isMapped = getServiceTemplateIntegratedIds(template).length > 0;
    const includedByMappedStatus = mappedStatusFilter.length === 0 || mappedStatusFilter.includes(MappedStatus.Mapped) && isMapped || mappedStatusFilter.includes(MappedStatus.Unmapped) && !isMapped;
    return includedBySearch && includedByMappedStatus;
  });
}
const mappedStatusFilterOptions = [{
  value: MappedStatus.Mapped,
  label: 'Mapped'
}, {
  value: MappedStatus.Unmapped,
  label: 'Unmapped'
}];
function PMMapServiceRow(_ref) {
  let {
    template,
    testid,
    items,
    getServiceTemplateIntegratedIds,
    onMapService
  } = _ref;
  const [integratedIds, setIntegratedIds] = useState(() => getServiceTemplateIntegratedIds(template));
  useDidUpdate(() => setIntegratedIds(getServiceTemplateIntegratedIds(template)), [template]);
  const isDeleted = serviceTemplateModel.isDeleted(template);
  return /*#__PURE__*/_jsx(TableList.Row, {
    size: "fluid",
    className: styles.row,
    items: [{
      value: /*#__PURE__*/_jsx(Typography, {
        ellipsis: true,
        skin: isDeleted ? 'secondary' : 'standard',
        children: "".concat(template.name).concat(isDeleted ? ' (Archived)' : '')
      })
    }, {
      value: /*#__PURE__*/_jsx(PMMapServiceField, {
        testid: "".concat(testid, "-mapping"),
        options: items,
        value: integratedIds,
        onChange: async ids => {
          setIntegratedIds(ids);
          onMapService(template, ids);
        }
      }, template.id)
    }]
  }, template.id);
}
function PMMapServicesTable(_ref2) {
  let {
    pmName,
    templates: initialTemplates,
    items,
    getServiceTemplateIntegratedIds,
    linkServiceTemplate,
    refresh
  } = _ref2;
  const {
    columnDefs,
    headerItems
  } = useMemo(() => getTableConfig(pmName), [pmName]);
  const [search, setSearch] = useState('');
  const [mappedStatusFilter, setMappedStatusFilter] = useState([]);
  const {
    showErrorToast
  } = useOverlayContext();
  const [templates, setTemplates] = useState(initialTemplates);
  const filteredTemplates = useMemo(() => filterTemplates(templates, search, mappedStatusFilter, getServiceTemplateIntegratedIds), [templates, search, mappedStatusFilter, getServiceTemplateIntegratedIds]);
  async function mapService(template, itemIds) {
    const result = await handlePromise(linkServiceTemplate(template.id, itemIds));
    if (!result.success) {
      await refresh();
      showErrorToast("Failed to map service ".concat(template.name), 'map-service-error-toast');
    }
    setTemplates(templates.map(t => {
      if (t.id === template.id) {
        const currentIntegrations = t.integrations;
        let updatedIntegrations;
        switch (pmName) {
          case PracticeManagement.Keeper:
            updatedIntegrations = currentIntegrations.setKeeperIntegratedIds(itemIds);
            break;
          case PracticeManagement.Karbon:
            updatedIntegrations = currentIntegrations.setKarbonIntegratedIds(itemIds);
            break;
          case PracticeManagement.ClientHub:
            updatedIntegrations = currentIntegrations.setClientHubIntegratedIds(itemIds);
            break;
          case PracticeManagement.FinancialCents:
            updatedIntegrations = currentIntegrations.setFinancialCentsIntegratedIds(itemIds);
            break;
        }
        return _objectSpread(_objectSpread({}, t), {}, {
          integrations: updatedIntegrations || t.integrations
        });
      }
      return t;
    }));
  }
  return /*#__PURE__*/_jsxs(TableList.Provider, {
    columnDefs: columnDefs,
    children: [/*#__PURE__*/_jsxs(PageContentHeader, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.filtersRow,
        children: [/*#__PURE__*/_jsx(Searchbox, {
          "data-testid": "services-search",
          value: search,
          onChange: e => setSearch(e.target.value),
          onClear: () => setSearch('')
        }), /*#__PURE__*/_jsx(MultiSelectFilterPicker, {
          value: mappedStatusFilter,
          options: mappedStatusFilterOptions,
          label: "Mapped status",
          onChange: setMappedStatusFilter,
          "data-testid": "mapped-status-filter"
        })]
      }), /*#__PURE__*/_jsx(TableList.Header, {
        items: headerItems
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: filteredTemplates.map((template, idx) => /*#__PURE__*/_jsx(PMMapServiceRow, {
        testid: "service-row-".concat(idx),
        items: items,
        template: template,
        getServiceTemplateIntegratedIds: getServiceTemplateIntegratedIds,
        onMapService: mapService
      }, template.id))
    })]
  });
}
export default function PMMapServicesModal(props) {
  const {
    pmName,
    dismissModal,
    getItems
  } = props;
  const serviceTemplateApi = useServiceTemplateApi();
  const {
    renderRestfulState
  } = useRestfulWrapper({
    fetch
  });
  async function fetch() {
    const [templates, items] = await Promise.all([serviceTemplateApi.getForMappingToPracticeManagementIntegration(), getItems()]);
    return {
      templates,
      items
    };
  }
  return /*#__PURE__*/_jsx(CustomModal, _objectSpread(_objectSpread({
    "data-testid": "pm-map-services-modal"
  }, modalSize.large), {}, {
    onClose: dismissModal,
    children: /*#__PURE__*/_jsx(Page, {
      height: "100%",
      header: "Map Services to ".concat(getPMDetails(pmName).name),
      skin: "secondary",
      children: renderRestfulState({
        renderChild: _ref3 => {
          let {
            data,
            refresh
          } = _ref3;
          return /*#__PURE__*/_jsx("div", {
            "data-testid": "pm-map-services-content",
            children: data.templates.length > 0 ? /*#__PURE__*/_jsx(PMMapServicesTable, _objectSpread(_objectSpread(_objectSpread({}, props), data), {}, {
              refresh: refresh
            })) : /*#__PURE__*/_jsx(PageEmptyState, {
              "data-testid": "pm-map-services-no-services",
              illustration: /*#__PURE__*/_jsx(NoDataIcon, {}),
              message: "In order to map with ".concat(getPMDetails(pmName).name, ", start by creating an agreement"),
              actions: /*#__PURE__*/_jsx(CreateProposalButton, {
                text: "Create a new agreement"
              })
            })
          });
        },
        renderLoader: () => /*#__PURE__*/_jsx(LoadingIndicator, {}),
        renderError: _ref4 => {
          let {
            refresh
          } = _ref4;
          return /*#__PURE__*/_jsx(PageErrorState, {
            "data-testid": "pm-map-services-fetch-error",
            message: ErrorText.IntegrationDataRetrieval,
            onRefresh: refresh,
            skin: "secondary"
          });
        }
      })
    })
  }));
}